import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AutomobileService } from '../shared/automobile.service';

@Component({
  selector: 'app-automobile-detail',
  templateUrl: './automobile-detail.component.html',
  styleUrls: ['./automobile-detail.component.css']
})
export class AutomobileDetailComponent implements OnInit {
dealerHandle: any;
details: any;
handle: any;
dealerData: any;
@Input()media:any

  constructor(private service: AutomobileService, private routeParam: ActivatedRoute,) { }

  ngOnInit(): void {
    this.handle = this.routeParam.snapshot.params['handle'];
    
    this.service.getAutomobileDetails(this.handle).subscribe(res => {
      if(res) {
        this.dealerData = res.payload.J[0];
      }
    })
    this.dealerHandle = this.routeParam.snapshot.params['id'];
    this.service.getAutomobileListDetails(this.dealerHandle).subscribe(res => {
      this.details = res.payload.J[0];
      this.media = res.payload.J1;
      console.log( this.media , ' this.media')
    })
  }

}
